import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../libs/utils";
import { cva } from "class-variance-authority";
import { forwardRef } from "react";
// Update the text variants to match the new sizing requirements
const textVariants = cva("text-foreground", {
    variants: {
        size: {
            xl: "text-base md:text-lg leading-relaxed",
            lg: "text-base leading-relaxed",
            default: "text-sm leading-normal",
            sm: "text-sm leading-normal",
            xs: "text-xs leading-normal",
        },
        weight: {
            normal: "font-normal",
            medium: "font-medium",
            semibold: "font-semibold",
        },
    },
    defaultVariants: {
        size: "default",
        weight: "normal",
    },
});
export const Text = forwardRef(({ className, size, weight, ...props }, ref) => {
    return _jsx("p", { ref: ref, className: cn(textVariants({ size, weight, className })), ...props });
});
Text.displayName = "Text";
//# sourceMappingURL=text.js.map